import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { LoginPage } from "./routes/LoginPage";
import { AccessDenied } from "./routes/AccessDenied";
import { MerchantTerminal } from "./routes/MerchantTerminal";
import { HAS_SUPABASE_CONFIG } from "./lib/env";

export function App() {
  const { status } = useAuth();

  if (!HAS_SUPABASE_CONFIG) {
    return (
      <div className="denied"><div className="denied__card">
        <h1>Nicht konfiguriert</h1>
        <p>VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY fehlen. Bitte lokale .env aus .env.example erstellen.</p>
      </div></div>
    );
  }

  if (status === "loading") {
    return <div className="splash" role="status" aria-live="polite">Terminal wird geladen…</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={status === "authorized" ? <Navigate to="/merchant/orders" replace /> : <LoginPage />} />
      <Route path="/denied" element={status === "denied" ? <AccessDenied /> : <Navigate to="/login" replace />} />
      <Route
        path="/merchant/orders"
        element={
          status === "authorized" ? <MerchantTerminal />
            : status === "denied" ? <Navigate to="/denied" replace />
            : <Navigate to="/login" replace />
        }
      />
      <Route path="*" element={<Navigate to={status === "authorized" ? "/merchant/orders" : status === "denied" ? "/denied" : "/login"} replace />} />
    </Routes>
  );
}
